<template>
	<v-navigation-drawer permanent :rail="mini" rail-width="48" width="380" mobile-breakpoint="0" color="panel_sub"
		theme="dark">
		<v-list-item :class="mini ? 'px-0' : ''">
			<template v-slot:prepend v-if="mini">
				<v-btn icon variant="text" @click.stop="toggleToolPanelMini()">
					<v-icon> icon:Chevron-Right</v-icon>
				</v-btn>
			</template>
			<template v-slot:title>
				<span @click="gotoList()" class="hover-blue">
					{{ $t("PROJECT") }}
				</span>
				<v-icon>icon:Chevron-Right</v-icon>
				{{ $store.state.site ? $store.state.site.site_name : "" }}
			</template>
			<template v-slot:append>
				<v-btn icon variant="text" @click.stop="toggleToolPanelMini()">
					<v-icon> icon:Chevron-Left </v-icon>
				</v-btn>
			</template>
		</v-list-item>
		<div class="left-area d-flex flex-row">
			<v-tabs v-model="tab" direction="vertical" bg-color="panel_sub" color="primary">
				<v-tab value="tab1" class="px-0 justify-center" @click="homeIconHandler">
					<v-icon> icon:Home </v-icon>
				</v-tab>
				<v-tab value="tab2" class="px-0 justify-center">
					<v-icon> icon:Setting </v-icon>
				</v-tab>
				<v-tab value="tab3" class="px-0 justify-center">
					<v-icon> mdi-rotate-45 mdi-ruler </v-icon>
				</v-tab>
				<v-tab v-if="showSpreadingCompactionTab" value="tab4" class="px-0 justify-center">
					<v-icon> mdi-layers-outline </v-icon>
				</v-tab>
				<div class="outer-link">
					<v-menu transition="slide-y-transition" location="end">
						<template v-slot:activator="{ props }">
							<info-tooltip placement="right" :triggers="['hover']">
								<v-tab :value="tab" v-bind="props" class="px-0 justify-center">
									<i class="fa-solid fa-up-right-from-square"></i>
								</v-tab>
								<template #popper>
									<span class="text-black">
										{{ $t("TOOLTIP_LABEL_OPEN_THE_EXTERNAL_PAGE") }}
									</span>
								</template>
							</info-tooltip>
						</template>
						<v-list density="compact" style="padding-top: 0; padding-bottom: 0;">
							<v-list-item @click="openDashboardSite">
								<v-icon class="wide-icon">icon:Dashboard</v-icon>
							</v-list-item>
							<v-list-item @click="openSimulationSite">
								<v-icon class="wide-icon">icon:Simulation</v-icon>
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
			</v-tabs>
			<v-window v-model="tab" direction="vertical" class="panel-main">
				<!-- ホームタブ -->
				<v-window-item value="tab1" class="tab">
					<v-card class="panel-main" color="panel_main">
						<v-card-title class="py-2 d-flex align-center justify-space-between">
							{{ $t("DATA_LAYERS") }}
						</v-card-title>
						<v-card-actions class="panel-main-item">
							<v-menu location="bottom start">
								<template v-slot:activator="{ props }">
									<v-btn class="add-btn" variant="flat" color="primary" rounded v-bind="props">
										<template v-slot:prepend>
											<v-icon size="20">icon:Add</v-icon>
										</template>
										{{ $t("ADD_DATA_LAYER") }}
									</v-btn>
								</template>
								<v-list density="compact" class="data-layer-add-menu">
									<v-list-item @click="onClickDataLayerUpload">
										<v-list-item-title class="data-layer-add-menu-title">{{ $t("FILE_UPLOAD") }}</v-list-item-title>
									</v-list-item>
									<v-list-item @click="onClickImportFromGroupware">
										<v-list-item-title class="data-layer-add-menu-title">{{ $t("IMPORT_FROM_GROUPWARE")
										}}</v-list-item-title>
									</v-list-item>
									<v-list-item @click="onClickImportFromDashboard">
										<v-list-item-title class="data-layer-add-menu-title">{{ $t("LOCALIZATION_FILE")
										}}</v-list-item-title>
									</v-list-item>
									<v-divider class="my-1"></v-divider>
									<v-list-item @click="onClickCreateReferenceTopology">
										<v-list-item-title class="data-layer-add-menu-title">{{ $t("CREATE_REFERENCE_TOPOLOGY")
										}}</v-list-item-title>
									</v-list-item>
									<v-list-item @click="onClickAddLineWorks">
										<v-list-item-title class="data-layer-add-menu-title">{{ $t("CREATE_LINEWORK") }}</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu>
							<add-data-dialog v-model="showAddDataDialog" :mode="addDataEntryMode" @close="closeAddDataDialog()" />
						</v-card-actions>
						<!-- オブジェクト選択ダイアログ画面 -->
						<v-card-actions class="panel-main-item">
							<v-btn class="add-btn" variant="flat" color="primary" rounded @click="openObjectDataDialog()"
								:disabled="isCreateBtnDisabled">
								<template v-slot:prepend>
									<v-icon size="20">icon:Add</v-icon>
								</template>
								{{ $t("BTN_OBJECT") }}
							</v-btn>
							<v-dialog :scrim="false" v-model="showObjectDataDialog" width="40%">
								<!-- 仮設道路AIは右側チャットから利用するため、オブジェクト追加リストには表示しない -->
								<object-data-dialog @data-to-parent="receiveData"
									@close="closeObjectDataDialog()" />
							</v-dialog>
						</v-card-actions>
						<!-- 仮設道路AI (prototype / PoC) -->
						<v-card-actions v-if="showPrototypeRoadAI" class="panel-main-item">
							<v-btn class="add-btn" variant="flat" color="secondary" rounded @click="openPrototypeRoadAI()">
								<template v-slot:prepend>
									<v-icon size="20">icon:Add</v-icon>
								</template>
								AI道路 (prototype)
							</v-btn>
						</v-card-actions>
						<!-- 簡易構造物ダイアログ・スナックバー -->
						<simple-structure-creator></simple-structure-creator>
						<v-card-actions>
							<v-dialog :scrim="false" v-model="isExclusion" width="300px">
								<exclusivity-notice-dialog @close="closeExclusivityNoticeDialog()" :exclusive_obj="exclusive_obj" />
							</v-dialog>
						</v-card-actions>
						<!-- drawing 2d image data-->
						<drawing-2d-image-list></drawing-2d-image-list>
						<!-- 基準地形 -->
						<point-cloud-list></point-cloud-list>
						<!-- 設計データ -->
						<design-list></design-list>
						<!-- 線形データ-->
						<line-works-list></line-works-list>
						<!-- グローブ表示切り替え -->
						<v-card-actions class="mx-3 my-3">
							{{ $t("globe") }} {{ $t("show") }} / {{ $t("hide") }}
							<v-switch class="globe-switch" v-model="globeVisibility" inset hide-details color="success"
								@update:model-value="globeVisibilityChanged()"></v-switch>
						</v-card-actions>
						<!-- オブジェクトリスト -->
						<object-list @updateGlobeVisibility="updateGlobeVisibility">
						</object-list>
						<!-- ソリッドメッシュリスト -->
						<solid-mesh-list></solid-mesh-list>
					</v-card>
				</v-window-item>
				<v-window-item value="tab2" class="tab">
					<v-card class="panel-main" color="panel_main">
						<v-card-title class="py-1">
							{{ $t("PROJECT_SETTINGS") }}
						</v-card-title>
						<v-card-text>
							<v-card-subtitle class="px-0 py-4">
								{{ $t("DISTANCE_UNITS") }}
							</v-card-subtitle>
							<v-table density="compact">
								<tbody>
									<tr>
										<td class="col-header">
											{{ $t("DISTANCE") }}
										</td>
										<td>{{ $t(distanceUnitNameKey) }}</td>
									</tr>
									<tr>
										<td>
											{{ $t("AREA") }}
										</td>
										<td>{{ $t(areaUnitNameKey) }}</td>
									</tr>
									<tr>
										<td>
											{{ $t("VOLUME") }}
										</td>
										<td>{{ $t(volumeUnitNameKey) }}</td>
									</tr>
									<!-- <tr>
										<td>
											{{ $t("SLOPE") }}
										</td>
										<td>
											<v-select v-model="unit" :items="unitTypes" item-text="label" item-value="value" density="compact"
												@change="changeSlopeUnit" hide-details class="px-1"></v-select>
										</td>
									</tr> -->
								</tbody>
							</v-table>
							<v-card-subtitle class="px-0 py-4">
								{{ $t("COORDINATE_SYSTEM") }}
							</v-card-subtitle>
							<v-table density="compact">
								<tbody>
									<tr>
										<td>{{ $t("LABEL_ROTATION") }}</td>
										<td>
											{{ truncateDecimals(siteInfo?.rotation, 5) }}
										</td>
									</tr>
									<tr>
										<td>{{ $t("LABEL_ORIGIN_EASTING") }}</td>
										<td>
											{{ truncateDecimals(siteInfo?.origin_easting, 5) }}
										</td>
									</tr>
									<tr>
										<td>{{ $t("LABEL_ORIGIN_NORTHING") }}</td>
										<td>
											{{ truncateDecimals(siteInfo?.origin_northing, 5) }}
										</td>
									</tr>
									<tr>
										<td>{{ $t("LABEL_ORIGIN_LATITUDE") }}</td>
										<td>
											{{ truncateDecimals(siteInfo?.origin_latitude, 5) }}
										</td>
									</tr>
									<tr>
										<td>{{ $t("LABEL_ORIGIN_LONGITUDE") }}</td>
										<td>
											{{ truncateDecimals(siteInfo?.origin_longitude, 5) }}
										</td>
									</tr>
									<tr>
										<td>{{ $t("LABEL_SCALE_FACTOR") }}</td>
										<td>
											{{ truncateDecimals(siteInfo?.scale_factor, 5) }}
										</td>
									</tr>
									<tr>
										<td>{{ $t("LABEL_VERTICAL_OFFSET") }}</td>
										<td>
											{{ truncateDecimals(siteInfo?.vertical_offset, 5) }}
										</td>
									</tr>
									<tr>
										<td>{{ $t("LABEL_INCLINE_X") }}</td>
										<td>
											{{ truncateDecimals(siteInfo?.incline_x, 5) }}
										</td>
									</tr>
									<tr>
										<td>{{ $t("LABEL_INCLINE_Y") }}</td>
										<td>
											{{ truncateDecimals(siteInfo?.incline_y, 5) }}
										</td>
									</tr>
									<tr>
										<td>{{ $t("LABEL_TO_METERS") }}</td>
										<td>
											{{ truncateDecimals(siteInfo?.to_meters, 5) }}
										</td>
									</tr>
									<tr>
										<td class="col-header">{{ $t("LABEL_COORDINATE_SYSTEM") }}</td>
										<td>
											{{ epsgLabel }}
										</td>
									</tr>
									<tr>
										<td>{{ $t("LABEL_VERTICAL_SHIFT") }}</td>
										<td>
											{{ epsgvLabel }}
										</td>
									</tr>
								</tbody>
							</v-table>
							<v-btn class=".rounded-lg mt-3 mr-5" color="#ff5050" height="25px" variant="flat" rounded
								@click="showDialog()">
								{{ $t("CHANGE_COORDINATE_SYSTEM") }}
							</v-btn>
						</v-card-text>
					</v-card>
				</v-window-item>
				<v-window-item value="tab3" class="tab">
					<v-card class="panel-main measurement" color="panel_main">
						<v-card-title class="py-1 d-flex align-center justify-space-between">
							{{ $t("MEASUREMENT") }}
						</v-card-title>
						<v-card-actions>
							<v-btn variant="flat" class="py-1 measure-btn" width="180px" color="primary" min-height="31px" rounded
								@click="toggleMeasurementMode">
								{{ $t("CREATE_LINEAR") }}
							</v-btn>
						</v-card-actions>
						<!-- 基準地形 -->
						<measurement-list></measurement-list>
					</v-card>
				</v-window-item>
				<!-- 転圧巻きだしタブ -->
				<v-window-item v-if="showSpreadingCompactionTab" value="tab4" class="tab">
					<spreading-compaction-tab-panel />
				</v-window-item>
			</v-window>
		</div>
		<v-dialog v-model="isWarningDialogOpen" width="600px" v-if="isWarningDialogOpen" persistent>
			<change-site-coordinate-system-dialog @close="closeWarningDialog" />
		</v-dialog>
		<v-dialog v-model="isFileDialogOpen" width="600px" v-if="isFileDialogOpen" persistent>
			<local-file-upload @close="closeFileUploadDialog" />
		</v-dialog>
	</v-navigation-drawer>
</template>

<script lang="ts">
import "@/assets/icons/style.css";
import { useGlobalDialogs } from "@/composables/useGlobalDialogs.js";
import { useUnitDisplay } from "@/composables/useUnitDisplay";
import config from "@/config.json";
import { ObjectType } from "@/models/objects/types";
import * as CesiumCommon from "@/utils/cesium-common";
import { notifyError, notifySuccess } from "@/utils/notificationUtils";
import axios from "axios";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { mapActions, mapMutations, mapState } from "vuex";
import {
	GoogleAnalyticsClickTypes,
	addClickTypeLog,
} from "../../utils/googleAnalytics.js";
import * as roadAIUtil from "../../utils/roadAIUtils";
import ChangeSiteCoordinateSystemDialog from "../AddData/ChangeSiteCoordinateSystemDialog.vue";
import LocalFileUpload from "../AddData/LocalFileUpload.vue";
import InfoTooltip from "../common/InfoTooltip.vue";
import AddDataDialog from "./AddDataDialog.vue";
// import AddLineWorksDialog from "./AddLineWorksDialog.vue";
import AddRoadTerrainByAI from "./AddRoadTerrainByAI.vue";
import DesignList from "./DesignList.vue";
import Drawing2dImageList from "./Drawing2dImageList.vue";
import ExclusivityNoticeDialog from "./ExclusivityNoticeDialog.vue";
import LineWorksList from "./LineWorks/LineWorksList.vue";
import MeasurementList from "./MeasurementList.vue";
import ObjectDataDialog from "./ObjectDataDialog.vue";
import ObjectList from "./ObjectList.vue";
import PointCloudList from "./PointCloudList.vue";
import SimpleStructureCreator from "./SolidMesh/SimpleStructureCreator.vue";
import SolidMeshList from "./SolidMesh/SolidMeshList.vue";
import SpreadingCompactionTabPanel from "./spreading-compaction/SpreadingCompactionTabPanel.vue";
import { handleFeatureTabTransition } from "./tabTransitionService";
dayjs.extend(isSameOrAfter);

export default {
	setup() {
		const { showPropertyDialogFoundationExcavation } = useGlobalDialogs();
		const { distanceUnitNameKey, areaUnitNameKey, volumeUnitNameKey } =
			useUnitDisplay();

		return {
			showPropertyDialogFoundationExcavation,
			distanceUnitNameKey,
			areaUnitNameKey,
			volumeUnitNameKey,
		};
	},
	name: "ToolPanel",
	components: {
		AddDataDialog,
		// AddLineWorksDialog,
		AddRoadTerrainByAI,
		PointCloudList,
		DesignList,
		ExclusivityNoticeDialog,
		LocalFileUpload,
		ObjectList,
		MeasurementList,
		SpreadingCompactionTabPanel,
		LineWorksList,
		ObjectDataDialog,
		ChangeSiteCoordinateSystemDialog,
		Drawing2dImageList,
		InfoTooltip,
		SolidMeshList,
		SimpleStructureCreator,
	},
	mounted: () => {},
	data: () => ({
		site: "現場名(モック)",
		config,
		mini: false,
		showAddDataDialog: false,
		addDataEntryMode: "local",
		// showAddLineWorksDialog: false,
		showViewerAgain: false,
		showObjectDataDialog: false,
		showStartEndPointConfirmDialog: false,
		isStartEndPointConfirm: false,
		globeVisibility: true,
		globeVisibilityBeforeCreationMode: false,
		disableRoadUpdate: false,
		exclusive_obj: null,
		isWarningDialogOpen: false,
		isFileDialogOpen: false,
		updateObjectListOfCreation: false,
		measurementMode: false,
		tab: "tab1",
		epsgLabel: "",
		epsgvLabel: "",
		inputTextField: {
			xValueMin: "",
			xValueMax: "",
			yValueMin: "",
			yValueMax: "",
			xyInterval: "",
			zValueMin: "",
			zValueMax: "",
			zInterval: "",
			allowMaxGradient: "",
			searchExpansionRadius: "",
		},
		designVisibilityBeforeAIRoad: null,
	}),
	computed: {
		...mapState(["modes"]),
		isEditMode() {
			// Do not treat as edit mode during 2-point alignment
			const drawing2d = this.$store.state.drawing2dImage;
			if (drawing2d?.isTwoPointAlignment) {
				return false;
			}
			const inEdit =
				this.$store.state.inProgressModeManager?.inProgressMode === "EDIT";
			const sc = this.$store.state.spreadingCompaction;
			const scEditing =
				sc?.isActive === true && (sc.selectedId !== null || sc.draft !== null);
			return inEdit || scEditing;
		},
		siteInfo() {
			return this.$store.getters.site;
		},
		// unitTypes() {
		//	 return UnitTypes.map((t) => ({ label: this.$t(t.label), value: t.value }));
		//	 // [
		//	 //	 {
		//	 //		 label: "Percent",
		//	 //		 value: "percent",
		//	 //		 symbol: "%"

		//	 //	 },
		//	 //	 {
		//	 //		 label: this.$t("RATIO_WORD"),
		//	 //		 value: "ratio",
		//	 //		 symbol: "1/n"
		//	 //	 },
		//	 //	 {
		//	 //		 label: "Degree",
		//	 //		 value: "degree",
		//	 //		 symbol: "°",
		//	 //	 },
		//	 // ];
		// },
		isCreateBtnDisabled() {
			let enableCreateObject = false;
			const visibleTerrainList = this.$store.getters.visibleTerrainList;
			if (visibleTerrainList.length >= 1 && visibleTerrainList.length <= 3) {
				const referenceTopologyList = visibleTerrainList.filter(
					(terrain) => terrain.getType() === "reference-topology",
				);
				const designList = visibleTerrainList.filter(
					(terrain) => terrain.getType() === "design",
				);
				const pointCloudList = visibleTerrainList.filter(
					(terrain) => terrain.getType() === "pointcloud",
				);
				if (
					referenceTopologyList.length <= 1 &&
					designList.length <= 1 &&
					pointCloudList.length <= 1
				) {
					enableCreateObject = true;
				}
			}

			return !enableCreateObject;
		},
		showSpreadingCompactionTab() {
			return window.featureFlag?.spreadingCompaction ?? false;
		},
		showPrototypeRoadAI() {
			// PoC (prototype) 仮設道路AI はデバッグフラグ有効時のみ表示する。
			return !!window.debugFlag?.debugPrototypeRoadAi;
		},
		isExclusion() {
			return this.$store.state.isExclusion;
		},
		cutSettingSlopeUnit() {
			return this.$store.state.cutSettingSlopeUnit;
		},
		fillSettingSlopeUnit() {
			return this.$store.state.fillSettingSlopeUnit;
		},
		pendingAction() {
			return this.$store.state.toolPanelActions?.pendingAction;
		},
	},
	watch: {
		isEditMode: {
			handler(newVal) {
				if (newVal) {
					// Wait for EditPanel DOM insertion and rendering to complete
					// to avoid interrupting the ToolPanel collapse animation.
					this.$nextTick(() => {
						requestAnimationFrame(() => {
							requestAnimationFrame(() => {
								// Re-check in case 2-point alignment started during delay (affects isEditMode)
								if (this.isEditMode) {
									this.mini = true;
								}
							});
						});
					});
				} else if (!newVal) {
					this.mini = false;
				}
			},
		},
		tab(newVal) {
			if (this.mini) {
				this.mini = false;
			}
			handleFeatureTabTransition(this.$store, newVal);
		},
		"siteInfo.epsg": {
			handler() {
				this.setCoordinateSystemLabel();
			},
			immediate: true,
		},
		"siteInfo.epsg_v": {
			handler() {
				this.setVerticalShiftLabel();
			},
			immediate: true,
		},
		pendingAction(actionType) {
			if (actionType === "roadAICreation") {
				this.roadAICreation();
				this.$store.dispatch("toolPanelActions/clearPendingAction");
			} else if (actionType === "reRoadAiCreation") {
				this.reRoadAiCreation();
				this.$store.dispatch("toolPanelActions/clearPendingAction");
			}
		},
	},
	methods: {
		...mapMutations([
			"set_snackbar",
			"reset_snackbars",
			"set_initial_site_data",
		]),
		...mapMutations("aiRoad", ["set_ai_road_point_selection"]),
		...mapActions(["get_point_cloud_list", "get_design_list", "get_obj_list"]),
		...mapActions("measurement", ["getMeasurementList"]),
		...mapActions("arbitraryLine", ["getArbitraryLineList"]),
		...mapActions("simaLine", ["getSimaLineList"]),
		...mapActions("drawing2dImage", ["getDrawing2dImageList"]),
		/**
		 * 小数点以下の指定した桁数nを超える部分を切り捨てる
		 * @param {*} num フォーマット対象の数字
		 * @param {*} n 小数点以下の桁数
		 */
		truncateDecimals(num, n) {
			if (typeof num === "number") {
				num = num.toString();
			}

			const regex = /^[+-]?\d+(\.\d+)?$/;
			// フォーマット対象が数値形式かチェック
			if (regex.test(num)) {
				// 小数点以下の桁数がnより多い場合は余分な桁数を切り捨てる
				if (num.indexOf(".") !== -1 && num.split(".")[1].length > n) {
					return Number.parseFloat(num).toFixed(n);
				}
				// 小数点なし or 小数点以下の桁数がn以下の数値は形式だけ変換する
				return Number.parseFloat(num);
			}
			// 数値でない場合はそのまま返す
			return num;
		},
		showWarningDialog() {
			this.isWarningDialogOpen = true;
		},
		closeWarningDialog(isProceed) {
			this.isWarningDialogOpen = false;
			if (isProceed) {
				this.showFileUploadDialog();
			}
		},
		showFileUploadDialog() {
			this.isFileDialogOpen = true;
		},
		closeFileUploadDialog() {
			this.isFileDialogOpen = false;
		},
		showDialog() {
			this.showWarningDialog();
		},
		globeVisibilityChanged() {
			window["viewer"].toggleGlobeVisibility(this.globeVisibility);
		},
		addRoadByJson() {
			// AIによる道路追加
			const dummyId = 1;
			const event = new CustomEvent("openPropertyDialog", {
				detail: { id: dummyId, type: 2 },
			});
			window.dispatchEvent(event);
		},
		openPrototypeRoadAI() {
			// 仮設道路AI (prototype / PoC) ダイアログを開く
			const event = new CustomEvent("openPropertyDialog", {
				detail: { id: 1, type: 100 },
			});
			window.dispatchEvent(event);
		},
		startEndPointConfirm() {
			this.isStartEndPointConfirm = true;
			this.showStartEndPointConfirmDialog = true;
		},
		// Unused (inventory PC-01). Remove after v1 access logs confirm there are no external calls.
		closeJsonDialog(dialogData) {
			const points = [];
			if (dialogData) {
				var file_to_read = dialogData;
				var fileread = new FileReader();
				const epsg = this.$store.state.site.epsg;
				const auth = this.$store.state.authObject;

				fileread.onload = (e) => {
					const content = e.target?.result;
					if (typeof content !== "string") return;
					var intern = JSON.parse(content);
					intern.controlPoints.forEach((item) => {
						points.push(item.position);
					});
					axios
						.post(
							`${import.meta.env.VITE_API_BASE}/pointcloud/processroadpoints`,
							{ points, epsg },
							{
								auth,
							},
						)
						.then((res) => {
							console.log(res.data);
							window["viewer"].createRoadFromPoints(
								res.data.points,
								(id) => {
									const event = new CustomEvent("openPropertyDialog", {
										detail: { id: id, type: 0 },
									});
									window.dispatchEvent(event);
								},
								this.$store.getters.activePointCloud?.getAssetIdNum(),
							);
						});
				};
				fileread.readAsText(file_to_read);
			} else {
			}
			this.$store.dispatch("inProgressModeManager/cancelCreation");
		},
		// Unused (inventory PC-01). Remove after v1 access logs confirm there are no external calls.
		closeStartEndPointConfirmDialog(dialogData) {
			const points = [];
			if (dialogData) {
				this.isStartEndPointConfirm = false;
				this.showStartEndPointConfirmDialog = false;
				var file_to_read = dialogData;
				var fileread = new FileReader();
				const epsg = this.$store.state.site.epsg;
				const auth = this.$store.state.authObject;

				fileread.onload = (e) => {
					const content = e.target?.result;
					if (typeof content !== "string") return;
					var intern = JSON.parse(content);
					intern.controlPoints.forEach((item) => {
						points.push(item.position);
					});
					axios
						.post(
							`${import.meta.env.VITE_API_BASE}/pointcloud/processroadpoints`,
							{ points, epsg },
							{
								auth,
							},
						)
						.then((res) => {
							console.log(res.data);
							window["viewer"].createRoadFromPoints(
								res.data.points,
								(id) => {
									const event = new CustomEvent("openPropertyDialog", {
										detail: { id: id, type: 0 },
									});
									window.dispatchEvent(event);
								},
								this.$store.getters.activePointCloud?.getAssetIdNum(),
							);
						});
				};
				fileread.readAsText(file_to_read);
			} else {
				this.isStartEndPointConfirm = false;
				this.showStartEndPointConfirmDialog = false;
			}
		},
		toggleToolPanelMini() {
			this.mini = !this.mini;
		},
		updateGlobeVisibility(visibility) {
			this.globeVisibility = visibility;
			window["viewer"].toggleGlobeVisibility(visibility);
		},
		async reRoadAiCreation() {
			try {
				const pointCloudAssetId =
					this.$store.state.addRoadTerrainByAi.pointCloudAssetId;
				const pointCloudId = this.$store.state.addRoadTerrainByAi.pointCloudId;
				const designId = this.$store.state.addRoadTerrainByAi.designId;
				const userId = this.$store.state.user?.id;

				// パラメータの更新
				const commandId = this.$store.getters["addRoadTerrainByAi/commandId"];
				const route = this.$store.getters["addRoadTerrainByAi/route"];
				const grade = this.$store.getters["addRoadTerrainByAi/grade"];
				const width = this.$store.getters["addRoadTerrainByAi/width"];
				this._setParameterFromCommand(commandId, route, width, grade);

				this.$store.dispatch("updateIsLoading", true);
				await roadAIUtil.setRoadJsonAI(
					this.$store,
					pointCloudAssetId,
					pointCloudId,
					designId,
					userId,
				);
			} catch (error) {
				console.error(error);
				this.$store.dispatch("addRoadTerrainByAi/add_chat_message", {
					role: "assistant",
					text: `仮設道路の作成に失敗しました。閉じてもう一度お試しください。${error?.message ? `（${error.message}）` : ""}`,
				});
				this.$store.dispatch("updateIsLoading", false);
			}
		},
		getActiveTerrain() {
			let activeTerrain;
			const visibleTerrainList = this.$store.getters.visibleTerrainList;
			if (visibleTerrainList.length >= 1 && visibleTerrainList.length <= 3) {
				const pointCloudList = visibleTerrainList.filter(
					(terrain) => terrain.getType() === "pointcloud",
				);
				const referenceTopologyList = visibleTerrainList.filter(
					(terrain) => terrain.getType() === "reference-topology",
				);
				const designList = visibleTerrainList.filter(
					(terrain) => terrain.getType() === "design",
				);
				if (pointCloudList.length === 1) {
					activeTerrain = pointCloudList[0];
				} else if (referenceTopologyList.length === 1) {
					activeTerrain = referenceTopologyList[0];
				} else if (designList.length === 1) {
					activeTerrain = designList[0];
				}
			}
			return activeTerrain;
		},
		// 仮設道路追加関数
		async roadCreation() {
			this.showViewerAgain = true;
			this.updateObjectListOfCreation = !this.updateObjectListOfCreation;
			this.globeVisibilityBeforeCreationMode = this.globeVisibility;
			const started = await this.$store.dispatch(
				"inProgressModeManager/startCreation",
			);
			if (!started) return;
			try {
				const activeTerrain = this.getActiveTerrain();
				if (activeTerrain) {
					this.$store.getters.viewer.enablePathCreation(
						(id) => {
							const event = new CustomEvent("openPropertyDialog", {
								detail: { id: id, type: 0 },
							});
							window.dispatchEvent(event);
						},
						{
							id: Number.parseInt(activeTerrain.getAssetId()),
							terrainType: activeTerrain.getType(),
						},
						{
							target: activeTerrain.getType(),
							id: Number.parseInt(activeTerrain.getAssetId()),
						},
					);
				} else {
					this.cancelRoadCreation();
					window.dispatchEvent(new CustomEvent("noPointCloudSelected"));
				}
			} catch (e) {
				this.cancelRoadCreation();
				console.error("Error on Road creation");
			}
		},
		setPointCloudAndDesign() {
			const pointCloudAssetId =
				this.$store.getters.activePointCloud?.getAssetIdNum();
			this.$store.dispatch(
				"addRoadTerrainByAi/update_point_cloud_asset_id",
				pointCloudAssetId,
			);
			const pointCloudId = this.$store.getters.activePointCloud?.getId();
			this.$store.dispatch(
				"addRoadTerrainByAi/update_point_cloud_id",
				pointCloudId,
			);
			const designId = this.$store.getters.activeDesign?.getId();
			this.$store.dispatch("addRoadTerrainByAi/update_design_id", designId);
		},
		// 設計データの表示状態を一時的に保存し、非表示にする
		hideDesignDataForAIRoad() {
			// 現在表示中の設計データを記録
			this.designVisibilityBeforeAIRoad = [];
			const designs = this.$store.getters.designs;

			designs.forEach((design, index) => {
				const isVisible = design.getVisibility();
				this.designVisibilityBeforeAIRoad.push({
					design: design,
					wasVisible: isVisible,
				});

				// 表示中の設計データを非表示にする
				if (isVisible) {
					// isShowとvisibilityの両方を設定
					design.isShow = false;
					design.visibility = false;
					this.changeDesignTransparency(design);
					window["viewer"].updateTilesetVisibility(
						Number.parseInt(design.asset_id),
						"design",
						false,
					);
				}
			});
		},
		// 設計データの表示状態を復元する
		restoreDesignDataAfterAIRoad() {
			if (this.designVisibilityBeforeAIRoad) {
				this.designVisibilityBeforeAIRoad.forEach((item, index) => {
					const { design, wasVisible } = item;

					if (wasVisible) {
						design.isShow = true;
						design.visibility = true;
						this.changeDesignTransparency(design);
						window["viewer"].updateTilesetVisibility(
							Number.parseInt(design.asset_id),
							"design",
							true,
						);
					}
				});
				this.designVisibilityBeforeAIRoad = null;
			}
		},
		// AI仮設道路追加関数
		async roadAICreation() {
			const pointCloudId =
				this.$store.getters["addRoadTerrainByAi/pointCloudId"];
			const designId = this.$store.getters["addRoadTerrainByAi/designId"];
			const pointCloudAssetId =
				this.$store.getters["addRoadTerrainByAi/pointCloudAssetId"];

			// AI道路生成開始前に設計データを一時的に非表示にする
			this.hideDesignDataForAIRoad();

			this.showViewerAgain = true;
			this.updateObjectListOfCreation = !this.updateObjectListOfCreation;
			this.globeVisibilityBeforeCreationMode = this.globeVisibility;
			const started = await this.$store.dispatch(
				"inProgressModeManager/startCreation",
			);
			if (!started) return;
			const userId = this.$store.state.user?.id;
			try {
				if (pointCloudAssetId) {
					const activeTerrain = this.getActiveTerrain();
					if (activeTerrain) {
						await window["viewer"].enablePathCreationWithClickCount(
							async (id) => {
								// スピナー開始
								this.$store.dispatch("updateIsLoading", true);
								try {
									await roadAIUtil.postPreprocess(
										pointCloudId,
										designId,
										this.$store.state.user?.id,
									);
									// 地形の前処理情報の取得
									const terrainInfo = await roadAIUtil.getTerrainInfo(
										pointCloudId,
										designId,
										this.$store.state.user?.id,
									);
									const preSettingsRoadObj = window["viewer"].getRoadJSON(id);
									const wgs84Points = preSettingsRoadObj.surveyPoints.map(
										(p) => p.wgs84Point,
									);
									const localPoints =
										await CesiumCommon.convertCoordinatesToPointCloudCrs(
											wgs84Points,
										);
									const startPoint = [
										localPoints[0].x,
										localPoints[0].y,
										localPoints[0].z,
									];
									const endPoint = [
										localPoints[localPoints.length - 1].x,
										localPoints[localPoints.length - 1].y,
										localPoints[localPoints.length - 1].z,
									];
									roadAIUtil.setInputTextFieldByTerrain(
										this.$store,
										terrainInfo,
										startPoint,
										endPoint,
										this.inputTextField,
									);
									// パラメータの更新
									const commandId =
										this.$store.getters["addRoadTerrainByAi/commandId"];
									const route = this.$store.getters["addRoadTerrainByAi/route"];
									const grade = this.$store.getters["addRoadTerrainByAi/grade"];
									const width = this.$store.getters["addRoadTerrainByAi/width"];
									this._setParameterFromCommand(commandId, route, width, grade);
									await roadAIUtil.setRoadJsonAI(
										this.$store,
										pointCloudAssetId,
										pointCloudId,
										designId,
										userId,
									);
									window["viewer"].deleteRoad(id);
									// AI道路生成完了後、設計データの表示状態を復元
									this.restoreDesignDataAfterAIRoad();
								} catch (error) {
									console.error(error);
									this.$store.dispatch("addRoadTerrainByAi/add_chat_message", {
										role: "assistant",
										text: `仮設道路の作成に失敗しました。閉じてもう一度お試しください。${error?.message ? `（${error.message}）` : ""}`,
									});
									this.restoreDesignDataAfterAIRoad();
									this.$store.dispatch("updateIsLoading", false);
								}
							},
							{
								id: Number.parseInt(activeTerrain.getAssetId()),
								terrainType: activeTerrain.getType(),
							},
							{
								target: activeTerrain.getType(),
								id: Number.parseInt(activeTerrain.getAssetId()),
							},
							2,
							pointCloudAssetId,
							null,
						);
					} else {
						this.restoreDesignDataAfterAIRoad();
					}
				} else {
					this.cancelRoadCreation();
					this.restoreDesignDataAfterAIRoad();
					window.dispatchEvent(new CustomEvent("noPointCloudSelected"));
				}
			} catch (e) {
				this.cancelRoadCreation();
				this.restoreDesignDataAfterAIRoad();
				console.error("Error on Road creation");
			}
		},
		// 仮設道路追加キャンセル
		cancelRoadCreation() {
			window["viewer"].cancelRoadCreation();
			this.$store.dispatch("inProgressModeManager/cancelCreation");
			this.restoreDesignDataAfterAIRoad();
		},
		// 平場追加
		async flatGroundCreation() {
			this.showViewerAgain = true;
			this.updateObjectListOfCreation = !this.updateObjectListOfCreation;
			this.globeVisibilityBeforeCreationMode = this.globeVisibility;
			const started = await this.$store.dispatch(
				"inProgressModeManager/startCreation",
			);
			if (!started) return;
			try {
				const activeTerrain = this.getActiveTerrain();
				if (activeTerrain) {
					window["viewer"].enablePolygonCreation(
						(id) => {
							const event = new CustomEvent("openPropertyDialog", {
								detail: { id: id, type: 1 },
							});
							window.dispatchEvent(event);
						},
						{
							id: Number.parseInt(activeTerrain.getAssetId()),
							terrainType: activeTerrain.getType(),
						},
						{
							target: activeTerrain.getType(),
							id: Number.parseInt(activeTerrain.getAssetId()),
						},
					);
				} else {
					this.cancelFlatGroundCreation();
					window.dispatchEvent(new CustomEvent("noPointCloudSelected"));
				}
			} catch {
				this.cancelFlatGroundCreation();
				console.error("Error on Added flat area");
			}
		},
		// 平場追加キャンセル
		cancelFlatGroundCreation() {
			window["viewer"].cancelFlatGroundCreation();
			this.$store.dispatch("inProgressModeManager/cancelCreation");
		},
		// 床掘追加
		async trenchCreation() {
			this.showViewerAgain = true;
			this.updateObjectListOfCreation = !this.updateObjectListOfCreation;
			this.globeVisibilityBeforeCreationMode = this.globeVisibility;
			const started = await this.$store.dispatch(
				"inProgressModeManager/startCreation",
			);
			if (!started) return;
			try {
				const activeTerrain = this.getActiveTerrain();
				if (activeTerrain) {
					window["viewer"].enableTrenchCreation(
						(id) => {
							const event = new CustomEvent("openPropertyDialog", {
								detail: { id: id, type: 7 },
							});
							window.dispatchEvent(event);
						},
						{
							id: Number.parseInt(activeTerrain.getAssetId()),
							terrainType: activeTerrain.getType(),
						},
						{
							target: activeTerrain.getType(),
							id: Number.parseInt(activeTerrain.getAssetId()),
						},
					);
				} else {
					this.cancelTrenchCreation();
					window.dispatchEvent(new CustomEvent("noPointCloudSelected"));
				}
			} catch {
				this.cancelTrenchCreation();
				console.error("Error on Added flat area");
			}
		},
		// 床掘追加キャンセル
		cancelTrenchCreation() {
			window["viewer"].cancelTrenchCreation();
			this.$store.dispatch("inProgressModeManager/cancelCreation");
		},
		/** ボタンクリック: ToolPanel側の準備 + Store の creation flow 起動 */
		onSimpleStructureCreationStarted() {
			this.showViewerAgain = true;
			this.updateObjectListOfCreation = !this.updateObjectListOfCreation;
			this.globeVisibilityBeforeCreationMode = this.globeVisibility;
			this.$store.dispatch("solidMesh/startSimpleStructureCreation");
		},
		isNum(val) {
			return typeof val == "number";
		},
		createFileName(date, objName, siteName) {
			return (
				[
					date.getFullYear(),
					this.padSingleDigit(date.getMonth() + 1),
					this.padSingleDigit(date.getDate()),
				].join("-") +
				" " +
				[
					this.padSingleDigit(date.getHours()),
					this.padSingleDigit(date.getMinutes()),
					this.padSingleDigit(date.getSeconds()),
				].join("_") +
				`_${siteName}_${objName}`
			);
		},
		padSingleDigit(num) {
			return num.toString().padStart(2, "0");
		},
		lang(lang) {
			this.$i18n.locale = lang;
		},
		onClickDataLayerUpload() {
			this.addDataEntryMode = "local";
			this.openAddDataDialog();
		},
		onClickImportFromGroupware() {
			addClickTypeLog(GoogleAnalyticsClickTypes.P_CLICK_GROUPWARE);
			this.addDataEntryMode = "groupware";
			this.openAddDataDialog();
		},
		onClickImportFromDashboard() {
			addClickTypeLog(GoogleAnalyticsClickTypes.P_CLICK_FROM_DASHBOARD);
			const dummyId = 1;
			const event = new CustomEvent("openPropertyDialog", {
				detail: { id: dummyId, type: 8 },
			});
			window.dispatchEvent(event);
		},
		async onClickCreateReferenceTopology() {
			addClickTypeLog(GoogleAnalyticsClickTypes.P_CLICK_REFERENCE_TOPOLOGY);
			const started = await this.$store.dispatch(
				"inProgressModeManager/startCreation",
			);
			if (!started) return;

			const onConstructionFinish = (data) => {
				const event = new CustomEvent("createDrawing2dImage", { detail: data });
				window.dispatchEvent(event);
			};

			window["viewer"].startDrawing2DImageConstruction({
				onFinish: onConstructionFinish,
				onCancel: () => {
					console.log("Reference Topology Construction cancelled");
				},
				onError: () => {
					console.log("Reference Topology Construction error");
				},
			});
		},
		async onClickAddLineWorks() {
			if (this.showViewerAgain) {
				this.showViewerAgain = false;
				await this.$store.dispatch("inProgressModeManager/cancelCreation");
			}
			this.showAddDataDialog = false;
			this.showObjectDataDialog = false;
			// this.showAddLineWorksDialog = false;
			await this.toggleLineWorkCreationMode();
		},
		openAddDataDialog() {
			this.showAddDataDialog = true;
			this.showObjectDataDialog = false;
			// this.showAddLineWorksDialog = false;
		},
		closeAddDataDialog() {
			this.showAddDataDialog = false;
			this.addDataEntryMode = "local";
		},
		async openObjectDataDialog() {
			if (this.showViewerAgain) {
				this.showViewerAgain = false;
				await this.$store.dispatch("inProgressModeManager/cancelCreation");
			}
			this.showAddDataDialog = false;
			// this.showAddLineWorksDialog = false;
			this.showObjectDataDialog = true;
		},
		closeObjectDataDialog() {
			this.showObjectDataDialog = false;
		},
		closeExclusivityNoticeDialog() {
			this.$store.commit("set_exclusion", false);
		},
		gotoList() {
			this.updateGlobeVisibility(true);
			window.location.href = "/";
		},
		async escapeKeyDown(event) {
			if (event.key == "Escape") {
				await this.$store.dispatch("inProgressModeManager/cancelCreation");
				// this.isRoadAdd = false;
				// this.isFlatAdd = false;
				// this.isTrenchAdd = false;
				// this.isArbitraryLineAdded = false;
			}
		},
		changeDesignTransparency(design) {
			window["viewer"].updateTilesetTransparency(
				design.getAssetIdNum(),
				"design",
				design.transparency,
			);
		},
		toggleDesignVisibility(design) {
			design.isShow = !design.isShow;
			this.changeDesignTransparency(design);
			window["viewer"].updateTilesetVisibility(
				design.getAssetIdNum(),
				"design",
				design.isShow,
			);
		},
		async toggleMeasurementMode() {
			// Google Analyticsに連携
			addClickTypeLog(GoogleAnalyticsClickTypes.P_CLICK_LINE_MEASUREMENT);
			const disabled = await this.$store.dispatch(
				"inProgressModeManager/disableAllInProgress",
			);
			if (!disabled) return;
			try {
				// 2点距離を取得
				this.measurementMode = true;
				const distanceInfo = await window["viewer"].enableMeasurementCreation();
				// ローディング開始
				this.$store.dispatch("updateIsLoading", true);
				// 登録リクエスト
				const res = await axios.post(
					`${import.meta.env.VITE_API_BASE}/twoPointsPicker/${this.$route.query.siteId}`,
					{
						start_info: distanceInfo.start,
						end_info: distanceInfo.end,
					},
				);
				if (res.status === 201) {
					// データリスト更新
					await this.getMeasurementList(this.$route.query.siteId);
					await this.$store.dispatch("measurement/displayNewMeasurement");
					notifySuccess(
						this,
						`${this.$t("CREATE_DISTANCE_POINTS")} ${this.$t("successful")}`,
					);
				}
			} catch {
				notifyError(
					this,
					`${this.$t("CREATE_DISTANCE_POINTS")} ${this.$t("failed")}`,
				);
			} finally {
				this.measurementMode = false;
				// ローディング終了
				this.$store.dispatch("updateIsLoading", false);
			}
		},
		async toggleLineWorkCreationMode() {
			const started = await this.$store.dispatch(
				"inProgressModeManager/startCreation",
			);
			if (!started) return;
			this.showViewerAgain = true;
			try {
				const activeTerrain = this.getActiveTerrain();
				if (activeTerrain) {
					await window["viewer"].enableArbitraryLineCreation(
						(viewerLineId) => {
							const event = new CustomEvent("openPropertyDialog", {
								detail: { id: viewerLineId, type: 9 },
							});
							window.dispatchEvent(event);
						},
						{
							id: Number.parseInt(activeTerrain.getAssetId()),
							terrainType: activeTerrain.getType(),
						},
					);
				}
			} catch (error) {
				window["viewer"].cancelArbitraryCreation();
				console.log(error);
			}
		},
		cancelArbitraryLineCreation() {
			window["viewer"].cancelArbitraryCreation();
			this.$store.dispatch("inProgressModeManager/cancelCreation");
		},
		homeIconHandler() {
			if (this.measurementMode) {
				window["viewer"].cancelMeasurement();
				this.measurementMode = false;
			}
		},
		async get_site_info() {
			const res = await axios.get(
				`${import.meta.env.VITE_API_BASE}/sites/${this.$route.query.siteId}`,
				{
					auth: this.$store.state.authObject,
				},
			);
			return res ? res.data : null;
		},
		receiveData(objData) {
			// 仮設道路追加
			if (objData === "road") this.roadCreation();
			// 平場追加
			else if (objData === "ground") this.flatGroundCreation();
			// 床掘追加
			else if (objData === "trench") this.trenchCreation();
			// 簡易構造物追加
			else if (objData === "simple_structure")
				this.onSimpleStructureCreationStarted();
			// 根伐り追加 (新規モード)
			else if (objData === "foundation_excavation")
				this.onFoundationExcavationCreationStarted();
			// AIによる道路追加
			else if (objData === "roadAI") {
				this.setPointCloudAndDesign();
				this.$emit("show-ai-chatbot");
			}
		},
		async onFoundationExcavationCreationStarted() {
			const started = await this.$store.dispatch(
				"inProgressModeManager/startCreation",
				{ objectType: ObjectType.FOUNDATION_EXCAVATION },
			);
			if (!started) return;
			this.showPropertyDialogFoundationExcavation = true;
		},
		async setCoordinateSystemLabel() {
			if (this.siteInfo) {
				const res = await axios.get(
					`${import.meta.env.VITE_API_BASE}/geospatial/coordinateSystem/${this.siteInfo?.epsg}`,
				);
				this.epsgLabel = res.data.length
					? res.data[0].label
					: this.siteInfo.epsg;
			}
		},
		async setVerticalShiftLabel() {
			if (this.siteInfo) {
				const res = await axios.get(
					`${import.meta.env.VITE_API_BASE}/geospatial/verticalShift/${this.siteInfo?.epsg_v}`,
				);
				this.epsgvLabel = res.data.length
					? res.data[0].label
					: this.siteInfo.epsg_v;
			}
		},
		async openDashboardSite() {
			// Google Analyticsに連携
			addClickTypeLog(GoogleAnalyticsClickTypes.P_CLICK_LINK_DASHBOARD);

			// show sipnner
			this.$store.dispatch("updateIsLoading", true);
			try {
				// get site-url for Dashboard
				const response = await axios.get(
					`${import.meta.env.VITE_API_BASE}/dashboard/${this.$route.query.siteId}/link`,
				);
				// show the Dashboard site in new tab
				window.open(response.data);
			} catch (e) {
				let message = this.$t("MESSAGE_ERROR_DEFAULT");
				if (e.response?.status === 404) {
					message = this.$t("MESSAGE_ERROR_NOT_FOUND_DASHBOARD_SITE");
				}
				// show snackbar
				notifyError(this, message);
			} finally {
				// hide spinner
				this.$store.dispatch("updateIsLoading", false);
			}
		},
		async openSimulationSite() {
			// Google Analyticsに連携
			addClickTypeLog(GoogleAnalyticsClickTypes.P_CLICK_LINK_SIMULATION);
			window.open(
				`${import.meta.env.VITE_SIMULATION_URL}/?site=${this.$route.query.siteId}`,
			);
		},
		_setParameterFromCommand(command, route, width, grade) {
			// commandによってsliderValueを設定する
			let sliderValue = {
				sliderValueCut: 0.1,
				sliderValueFill: 0.1,
				sliderValueOverFill: 1.0,
				sliderValueOverCut: 1.0,
				sliderValueCfDiff: 0.1,
				sliderValueRoute: 0.1,
			};
			switch (command) {
				case 1:
					sliderValue = {
						sliderValueCut: 0.1,
						sliderValueFill: 0.1,
						sliderValueOverFill: 1.0,
						sliderValueOverCut: 1.0,
						sliderValueCfDiff: 1.0,
						sliderValueRoute: route,
					};
					break;
				case 2:
					sliderValue = {
						sliderValueCut: 1.0,
						sliderValueFill: 0.1,
						sliderValueOverFill: 1.0,
						sliderValueOverCut: 1.0,
						sliderValueCfDiff: 0.1,
						sliderValueRoute: route,
					};
					break;
				case 3:
					sliderValue = {
						sliderValueCut: 0.1,
						sliderValueFill: 1.0,
						sliderValueOverFill: 1.0,
						sliderValueOverCut: 1.0,
						sliderValueCfDiff: 0.1,
						sliderValueRoute: route,
					};
					break;
				case 4:
					sliderValue = {
						sliderValueCut: 1.0,
						sliderValueFill: 1.0,
						sliderValueOverFill: 1.0,
						sliderValueOverCut: 1.0,
						sliderValueCfDiff: 0.1,
						sliderValueRoute: route,
					};
					break;
				case 5:
					sliderValue = {
						sliderValueCut: 1.0,
						sliderValueFill: 1.0,
						sliderValueOverFill: 1.0,
						sliderValueOverCut: 1.0,
						sliderValueCfDiff: 1.0,
						sliderValueRoute: route,
					};
					break;
				default:
					sliderValue = {
						sliderValueCut: 0.1,
						sliderValueFill: 0.1,
						sliderValueOverFill: 1.0,
						sliderValueOverCut: 1.0,
						sliderValueCfDiff: 0.1,
						sliderValueRoute: route,
					};
			}
			roadAIUtil.setSliderInfo(this.$store, sliderValue);
			roadAIUtil.setAllowMaxGradient(this.$store, grade);
			roadAIUtil.setSearchExpansionRadius(this.$store, grade);
			this.$store.dispatch("addRoadTerrainByAi/update_left_with", width / 2);
			this.$store.dispatch("addRoadTerrainByAi/update_right_with", width / 2);
		},
	},
	async created() {
		try {
			window.addEventListener("keydown", this.escapeKeyDown);
			const res = await this.get_site_info();
			this.$store.commit("set_initial_site_datas", res);
		} catch (error) {
			console.error(error.message);
		}
	},
	unmounted() {
		window.removeEventListener("keydown", this.escapeKeyDown);
		this.set_ai_road_point_selection(false);
		window["viewer"].removeAIRoadPreview();
	},
};
</script>

<style scoped>
.v-tab {
	min-width: 48px !important;
	width: 48px;
}

.left-area {
	width: 100%;
	/* 104px = 56px + 48px */
	height: calc(100vh - 104px);
}

.outer-link {
	margin-top: auto;
}

.panel-main {
	width: 100%;
	height: 100%;
	overflow-y: auto;
}

.tab {
	height: 100%;
}

td {
	padding: 0px 8px 0px 8px !important;
}

.hover-blue:hover {
	color: #1976d2;
}

.highlight {
	background-color: #004f93 !important;
	border: #ffffff solid 1px;
}

.Doing {
	background-color: #0064ba !important;
	border: #0064ba solid 2px;
}

.Doing:hover {
	background-color: #0059a6 !important;
	border: #0059a6 solid 2px;
}

.list-doing:hover {
	background-color: #0064ba !important;
}

.list-delayed:hover {
	background-color: #b90007;
}

.v-btn--disabled.multiple-pc {
	pointer-events: unset !important;
}

.panel-main-item {
	min-height: 32px;
	padding: 0;
	margin-bottom: 8px;
}

.add-btn {
	justify-content: space-between;
	width: 250px;
	height: auto;
	margin: 0 auto 0 25px;
	padding: 4px 16px;
	min-width: 0;
}

:deep(.add-btn .v-btn__prepend),
:deep(.add-btn .v-btn__append) {
	flex: 0 0 auto;
}

:deep(.add-btn .v-btn__content) {
	white-space: normal;
	overflow-wrap: anywhere;
	word-break: break-word;
	text-align: center;
	min-width: 0;
	flex: 1 1 auto;
	line-height: 1.3;
}

.data-layer-add-menu {
	width: 270px;
	max-width: 270px;
	padding: 6px;
	border: 1px solid rgba(255, 255, 255, 0.18);
	border-radius: 12px;
	/* box-shadow: 0 10px 26px rgba(0, 0, 0, 0.35);
	backdrop-filter: blur(2px); */
}

.data-layer-add-menu-title {
	font-size: 15px;
	line-height: 1.25;
	white-space: normal;
}

.globe-switch {
	position: absolute;
	right: 10px;
}

.col-header {
	width: 40%;
}

.measure-btn {
	margin: 0px auto;
	white-space: normal !important;
	height: auto;
}

:deep(div.panel-main.measurement.v-card.v-sheet) {
	height: 100%;
}

:deep(.bg-panel_main) {
	padding-bottom: 16px;
}

.wide-icon {
	width: 85%;
	height: 85%;
	margin: 5px 0px;
	display: inline-flex;
	justify-content: center;
}
</style>
